<template>
  <header
    class="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 backdrop-blur-sm bg-white/95 dark:bg-gray-800/95 w-full"
  >
    <div class="px-4 my-2 pt-safe">
      <div class="flex items-center justify-between h-10">
        <!-- Logo/Title -->
        <div class="flex items-center space-x-3">
          <div class="w-8 h-8 rounded-lg flex items-center justify-center">
            <img
              src="@/assets/images/centerstage-logo.png"
              alt="CenterStage Logo"
              class="w-8 h-8 object-contain"
            />
          </div>
          <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
            {{ pageTitle }}
          </h1>
        </div>

        <!-- Actions -->
        <div class="flex items-center space-x-2">
          <!-- Theme Toggle -->
          <Button
            :icon="themeStore.isDark ? 'pi pi-sun' : 'pi pi-moon'"
            severity="secondary"
            text
            rounded
            class="w-10 h-10"
            @click="themeStore.toggleTheme()"
            v-tooltip.bottom="themeStore.isDark ? 'Light Mode' : 'Dark Mode'"
          />

          <!-- Settings -->
          <Button
            icon="pi pi-cog"
            severity="secondary"
            text
            rounded
            class="w-10 h-10"
            @click="$router.push('/settings')"
            v-tooltip.bottom="'Settings'"
          />

          <!-- Logout -->
          <Button
            icon="pi pi-sign-out"
            severity="secondary"
            text
            rounded
            class="w-10 h-10"
            @click="handleLogout"
            v-tooltip.bottom="'Sign Out'"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import Button from "primevue/button";
import { useThemeStore } from "@/stores/theme";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const router = useRouter();
const themeStore = useThemeStore();
const authStore = useAuthStore();

const pageTitle = computed(() => {
  return (route.meta?.title as string) || "ScantixPro";
});

async function handleLogout() {
  await authStore.logout();
  router.push("/login");
}
</script>
